import * as d3 from 'd3';


// export default function buildTaxonomicTree(flatData) {
//     const dataMap = {};
//     flatData.forEach(item => {
//         dataMap[item.taxon.ncbi_id] = {
//             ...item.taxon,
//             count: item.count,
//             children: []
//         };
//     });

//     let root = null;

//     flatData.forEach(item => {
//         const taxon = dataMap[item.taxon.ncbi_id];
//         const parentNcbiId = item.taxon.parent_ncbi_id;

//         if (parentNcbiId === null) {
//             root = taxon;
//         } else {
//             const parent = dataMap[parentNcbiId];
//             if (parent) {
//                 parent.children.push(taxon);
//             }
//         }
//     });
//     console.log(root)

//     return root;
// }


// export default function buildTaxonomicTree(taxonomicData) {
//     // console.log(taxonomicData[]);
//     // const root = d3.stratify()
//     //     .id((d) => d.taxon.ncbi_id)
//     //     .parentId((d) => d.taxon.parent_ncbi_id)
//     //     (taxonomicData.slice(9));

//     const nodeMap = {};
//     let root = null;

//     taxonomicData.forEach(({ taxon, count }) => {
//         const { ncbi_id, name, rank, parent_ncbi_id } = taxon;

//         if (!nodeMap[ncbi_id]) {
//             nodeMap[ncbi_id] = {
//                 // name: name,
//                 // rank: rank,
//                 count: count,
//                 children: {}
//             };
//         }

//         nodeMap[ncbi_id].count = count;

//         if (parent_ncbi_id !== null) {
//             if (!nodeMap[parent_ncbi_id]) {
//                 nodeMap[parent_ncbi_id] = {
//                     children: {}
//                 };
//             }
//             const parentRank = nodeMap[parent_ncbi_id].children[rank] || {};
//             parentRank[name] = nodeMap[ncbi_id];
//             nodeMap[parent_ncbi_id].children[rank] = parentRank;
//         } else {
//             root = nodeMap[ncbi_id];
//         }
//     });

//     return root;
// }



// export default function buildTaxonomicTreeSingle(taxonomicData) {
//     console.log(taxonomicData);

//     // console.log(taxonomicData);


//     const nodeMap = {};
//     let root = null;

//     taxonomicData.forEach(({ taxon, count }) => {
//         const { ncbi_id, name, rank, parent_ncbi_id } = taxon;

//         if (!nodeMap[ncbi_id]) {
//             nodeMap[ncbi_id] = {
//                 name: name,
//                 rank: rank,
//                 count: count,
//                 children: []
//             };
//         }

//         nodeMap[ncbi_id].count = count;

//         if (parent_ncbi_id !== null) {
//             if (!nodeMap[parent_ncbi_id]) {
//                 nodeMap[parent_ncbi_id] = {
//                     children: []
//                 };
//             }

//             nodeMap[parent_ncbi_id].children.push(nodeMap[ncbi_id]);
//         } else {
//             root = nodeMap[ncbi_id];
//         }
//     });
//     // console.log(root);


//     return root;
// };
// export default function buildTaxonomicTreeSingle(taxonomicData, domain = 'bacteria') {


// export default function buildTaxonomicTreeSingle(taxonomicData, domain = 'bacteria') {
//     const nodeMap = {};
//     const availableDomains = new Set();

//     // forced_parent_child_relationship_order = ['sk', 'p', 'c', 'o', 'f', 'g', 's']

//     // build unified root
//     const unifiedRoot = {
//         name: "root",
//         rank: "root",
//         count: 0,
//         children: []
//     };

//     // build node map and track available domains
//     taxonomicData.forEach(({ taxon, count }) => {
//         // console.log(taxon, count);
//         // if (taxon === undefined) {
//         //     console.log(taxon);
//         // }
//         // if (not(taxon)) {

//         // }
//         // console.log(count);




//         const { ncbi_id, name, rank, parent_ncbi_id } = taxon;

//         // console.log(name === undefined);

//         if (rank === 'sk') {
//             availableDomains.add(name.toLowerCase());
//         }

//         if (!nodeMap[ncbi_id]) {
//             nodeMap[ncbi_id] = {
//                 name,
//                 rank,
//                 count,
//                 children: []
//             };
//         }
//         nodeMap[ncbi_id].count = count;

//         if (parent_ncbi_id !== null) {
//             if (!nodeMap[parent_ncbi_id]) {
//                 nodeMap[parent_ncbi_id] = {
//                     children: [],
//                     count: 0
//                 };
//             }
//             nodeMap[parent_ncbi_id].children.push(nodeMap[ncbi_id]);
//         } else {
//             unifiedRoot.children.push(nodeMap[ncbi_id]);
//         }
//     });

//     const targetDomain = domain.toLowerCase();
//     const domainNode = unifiedRoot.children.find(child =>
//         child.rank === 'sk' && child.name.toLowerCase() === targetDomain
//     );

//     console.log(domainNode);

//     return {
//         tree: domainNode || unifiedRoot,
//         availableDomains: Array.from(availableDomains)
//     };
// }

export default function buildTaxonomicTreeSingle(taxonomicData, domain = 'bacteria') {
    const nodeMap = {};
    const availableDomains = new Set();

    const forced_parent_child_relationship_order = ['sk', 'p', 'c', 'o', 'f', 'g', 's'];

    // build unified root
    const unifiedRoot = {
        name: "root",
        rank: "root",
        count: 0,
        children: []
    };

    const isValidRank = (rank) => forced_parent_child_relationship_order.includes(rank);

    // Function to check if parent-child relationship follows correct order
    const isValidRelationship = (parentRank, childRank) => {
        if (parentRank === "root" && childRank === "sk") return true;

        const parentIndex = forced_parent_child_relationship_order.indexOf(parentRank);
        const childIndex = forced_parent_child_relationship_order.indexOf(childRank);

        // Both ranks must be valid and parent must come before child in hierarchy
        return parentIndex !== -1 && childIndex !== -1 && parentIndex < childIndex;
    };

    // First pass: build node map and track available domains
    taxonomicData.forEach(({ taxon, count }) => {
        if (!taxon) return;

        const { ncbi_id, name, rank, parent_ncbi_id } = taxon;

        // Skip taxa with invalid ranks
        if (!isValidRank(rank)) return;

        if (rank === 'sk') {
            availableDomains.add(name.toLowerCase());
        }

        if (!nodeMap[ncbi_id]) {
            nodeMap[ncbi_id] = {
                name,
                rank,
                count,
                children: []
            };
        }
        nodeMap[ncbi_id].count = count;
    });

    taxonomicData.forEach(({ taxon }) => {
        if (!taxon) return;

        const { ncbi_id, rank, parent_ncbi_id } = taxon;

        if (!isValidRank(rank) || !nodeMap[ncbi_id]) return;

        if (parent_ncbi_id !== null) {
            if (!nodeMap[parent_ncbi_id]) return;

            const parentRank = nodeMap[parent_ncbi_id].rank || "unknown";

            if (!isValidRelationship(parentRank, rank)) return;

            nodeMap[parent_ncbi_id].children.push(nodeMap[ncbi_id]);
        } else {
            if (rank === 'sk') {
                unifiedRoot.children.push(nodeMap[ncbi_id]);
            }
        }
    });

    const targetDomain = domain.toLowerCase();
    const domainNode = unifiedRoot.children.find(child =>
        child.rank === 'sk' && child.name.toLowerCase() === targetDomain
    );

    return {
        tree: domainNode || unifiedRoot,
        availableDomains: Array.from(availableDomains)
    };
}




// const nestedTaxonomy = buildTaxonomicTree(taxonomicData);

// console.log(JSON.stringify(nestedTaxonomy, null, 2));

// const root = d3.hierarchy(nestedTaxonomy);

// eg output:
// {
//     "name": "Archaea",
//     "rank": "sk",
//     "count": 740,
//     "children": {
//       "p": {
//         "Thermoproteota": {
//           "name": "Thermoproteota",
//           "rank": "p",
//           "count": 110,
//           "children": {}
//         },
//         "Methanobacteriota": {
//           "name": "Methanobacteriota",
//           "rank": "p",
//           "count": 171,
//           "children": {
//             "c": {
//               "Thermococci": {
//                 "name": "Thermococci",
//                 "rank": "c",
//                 "count": 5,
//                 "children": {}
//               },
//               "Thermoplasmata": {
//                 "name": "Thermoplasmata",
//                 "rank": "c",
//                 "count": 163,
//                 "children": {
//                   "o": {
//                     "Methanomassiliicoccales": {
//                       "name": "Methanomassiliicoccales",
//                       "rank": "o",
//                       "count": 2,
//                       "children": {}
//                     }
//                   }
//                 }
//               }
//             }
//           }
//         },
//         "Nitrososphaerota": {
//           "name": "Nitrososphaerota",
//           "rank": "p",
//           "count": 139,
//           "children": {
//             "o": {
//               "Nitrosopumilales": {
//                 "name": "Nitrosopumilales",
//                 "rank": "o",
//                 "count": 138,
//                 "children": {
//                   "f": {
//                     "Nitrosopumilaceae": {
//                       "name": "Nitrosopumilaceae",
//                       "rank": "f",
//                       "count": 138,
//                       "children": {
//                         "g": {
//                           "Nitrosopumilus": {
//                             "name": "Nitrosopumilus",
//                             "rank": "g",
//                             "count": 1,
//                             "children": {
//                               "s": {
//                                 "Nitrosopumilus sp. DDS1": {
//                                   "name": "Nitrosopumilus sp. DDS1",
//                                   "rank": "s",
//                                   "count": 1,
//                                   "children": {}
//                                 }
//                               }
//                             }
//                           }
//                         }
//                       }
//                     }
//                   }
//                 }
//               }
//             }
//           }
//         }
//       }
//     }
//   }